(function () {
  'use strict';

  /* ─── Intersection Observer: generic fade-up / slide-in ─── */
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.dataset.revealDelay || '0', 10);
      if (delay) {
        setTimeout(function () { el.classList.add('is-visible'); }, delay);
      } else {
        el.classList.add('is-visible');
      }
      revealObserver.unobserve(el);
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.hj__fade-up, .hj__slide-in-left').forEach(function (el) {
    revealObserver.observe(el);
  });

  /* ─── Step cards: slide-in with stagger ─── */
  document.querySelectorAll('.hj__cc-step').forEach(function (card, i) {
    card.classList.add('hj__slide-in-left');
    card.dataset.revealDelay = i * 100;
    revealObserver.observe(card);
  });

  /* ─── Review bubbles: fade-up with stagger ─── */
  document.querySelectorAll('.hj__cc-bubble-wrap').forEach(function (wrap, i) {
    wrap.classList.add('hj__fade-up');
    wrap.dataset.revealDelay = i * 150;
    revealObserver.observe(wrap);
  });

  /* ─── Count-up for stat numbers ─── */
  function countUp(el, duration) {
    var target = parseInt(el.dataset.countTarget || '0', 10);
    var suffix = el.dataset.countSuffix || '';
    if (!target) return;
    var startTime = performance.now();
    function step(now) {
      var progress = Math.min((now - startTime) / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(ease * target) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var statsObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      statsObserver.unobserve(entry.target);
      entry.target.querySelectorAll('[data-count-target]').forEach(function (el) {
        countUp(el, 1500);
      });
    });
  }, { threshold: 0.3 });

  var statsSection = document.querySelector('.hj__cc-stats');
  if (statsSection) statsObserver.observe(statsSection);

  /* ─── Product row arrow navigation (desktop) ─── */
  function getCardStep(scroll) {
    var card = scroll.querySelector('.hj__card');
    return card ? card.offsetWidth + 12 : 292;
  }

  function updateRowBtns(row) {
    var scroll  = row.querySelector('.hj__cc-row-scroll');
    var prevBtn = row.querySelector('[data-dir="prev"]');
    var nextBtn = row.querySelector('[data-dir="next"]');
    if (!scroll || !prevBtn || !nextBtn) return;

    prevBtn.disabled = scroll.scrollLeft < 4;
    nextBtn.disabled = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 4;
  }

  function initProductRows() {
    document.querySelectorAll('.hj__cc-row').forEach(function (row) {
      var scroll = row.querySelector('.hj__cc-row-scroll');
      if (!scroll || scroll.dataset.navBound === 'true') {
        updateRowBtns(row);
        return;
      }
      scroll.dataset.navBound = 'true';
      scroll.addEventListener('scroll', function () { updateRowBtns(row); }, { passive: true });
      updateRowBtns(row);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hj__cc-row-nav-btn[data-dir]');
    if (!btn) return;

    var row = btn.closest('.hj__cc-row');
    var scroll = row && row.querySelector('.hj__cc-row-scroll');
    if (!scroll) return;

    var dir = btn.dataset.dir === 'prev' ? -1 : 1;
    scroll.scrollBy({ left: dir * getCardStep(scroll), behavior: 'smooth' });
    window.setTimeout(function () { updateRowBtns(row); }, 260);
  });

  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-cc-row-load]');
    if (!button) return;

    var row = button.closest('.hj__cc-row');
    if (!row) return;

    var step = parseInt(button.dataset.step || '4', 10);
    var hiddenCards = Array.prototype.slice.call(row.querySelectorAll('[data-cc-row-card].is-hidden'));
    hiddenCards.slice(0, step).forEach(function (card) {
      card.classList.remove('is-hidden');
      card.classList.add('is-visible');
    });

    if (!row.querySelector('[data-cc-row-card].is-hidden')) {
      if (button.dataset.hasMore === 'true' && button.dataset.viewAllReady !== 'true') {
        button.dataset.viewAllReady = 'true';
        button.textContent = button.dataset.viewAllText || 'View all';
        button.setAttribute('aria-label', button.textContent);
        return;
      }

      if (button.dataset.viewAllReady === 'true' && button.dataset.viewAllUrl) {
        window.location.href = button.dataset.viewAllUrl;
        return;
      }

      var more = button.closest('.hj__cc-row-more');
      if (more) more.hidden = true;
    }
  });

  initProductRows();
  document.addEventListener('shopify:section:load', initProductRows);

  /* ─── Comparison slider ─── */
  document.querySelectorAll('[data-compare]').forEach(function (wrap) {
    var after  = wrap.querySelector('.hj__cc-compare-img--after');
    var handle = wrap.querySelector('.hj__cc-compare-handle');
    var active = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct  = Math.min(Math.max((clientX - rect.left) / rect.width * 100, 0), 100);
      after.style.clipPath = 'inset(0 ' + (100 - pct).toFixed(2) + '% 0 0)';
      handle.style.left    = pct + '%';
    }

    wrap.addEventListener('pointerdown', function (e) {
      active = true;
      wrap.setPointerCapture(e.pointerId);
      setPos(e.clientX);
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!active) return;
      setPos(e.clientX);
    });
    wrap.addEventListener('pointerup',     function () { active = false; });
    wrap.addEventListener('pointercancel', function () { active = false; });
  });

  /* ─── Hero CTA + Final CTA: scroll to first product section ─── */
  function scrollToProducts() {
    var target = document.querySelector('.hj__cc-products');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  var heroCta = document.querySelector('.hj__cc-hero-cta');
  if (heroCta) heroCta.addEventListener('click', scrollToProducts);

  var finalCta = document.querySelector('.hj__cc-final-cta');
  if (finalCta) finalCta.addEventListener('click', scrollToProducts);

  window.HJ_COUPLE_COLLECTION_VERSION = 'fd-tee-create-refresh-20260523';

})();
